import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { PoBreadcrumb, PoTableColumnSpacing } from '@po-ui/ng-components';
import { PoPageDynamicEditActions, PoPageDynamicEditField } from '@po-ui/ng-templates';
import { SchemaBuilderService } from '../../../core/menu/schema-builder.service';

@Component({
  selector: 'app-notas-fiscais-edit',
  templateUrl: './notas-fiscais-edit.component.html',
  styleUrls: ['./notas-fiscais-edit.component.css'],
  standalone: false
})
export class NotasFiscaisEditComponent implements OnInit {

  readonly serviceApi = `${environment.apiUrl}${environment.versionApi}/nfs`;

  public readonly breadcrumb: PoBreadcrumb = {
      items: [{ label: 'Home', link: '/' }, { label: 'Cadastro Notas Fiscais', link: '/nf' }, { label: 'Edição Notas Fiscais' }]
  };

  public readonly actions: PoPageDynamicEditActions = {
      save: 'nfs',
      // saveNew: '/cliente',
  };

  fields: PoPageDynamicEditField[] = []
  poTableColumnSpacing: PoTableColumnSpacing = PoTableColumnSpacing.Small;


  constructor(private readonly schemaBuilderService: SchemaBuilderService) { }

  ngOnInit(): void {
    this.schemaBuilderService.getFieldSchema("nf").subscribe((data) => {
        this.fields = data;
    });
  }
}
